import { useContext, useRef, useState, useEffect, useCallback } from "react";
import { useStyles } from "../../Styles/styles";
import { SetupContext } from "../../Contexts/SetupContext";
import { styled } from "styled-components";
import MultiDropDownObjects from "../MultiDropDownObjects";
import SingleDropDown from "../SingleDropDown";
import clsx from "clsx";

const UOFContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const UseOfForce = ({
  handleChange,
  uofInstance,
  uofInstanceTypes,
  uofInjuryDetails,
  userRoles,
  showValidation = false,
  ...props
}) => {
  const classes = useStyles();
  const { setup } = useContext(SetupContext);
  const {
    uofInstances,
    uofInstanceTypes: uofInstanceTypess,
    uofInjuryDetails: uofInjuryDetailss,
  } = setup.setupLists;
  const inputLabel = useRef(null);
  const [labelWidth, setLabelWidth] = useState(0);

  useEffect(() => {
    if (inputLabel.current) {
      setLabelWidth(inputLabel.current.offsetWidth);
    }
  }, [inputLabel]);

  const removeNoneFromUofType = useCallback(() => {
    const typeIncludesNone = uofInstanceTypes?.some(type =>
      type?.name?.includes("None"),
    );
    if (typeIncludesNone) {
      const noneTypeRemoved = uofInstanceTypes?.filter(
        type => !type?.name?.includes("None"),
      );
      const typeMockEvent = {
        target: {
          type: "useEffect",
          name: "uofInstanceTypes",
          value: noneTypeRemoved,
        },
      };
      handleChange(typeMockEvent, true, false);
    }
  }, [handleChange, uofInstanceTypes]);

  const removeNoneFromUofInjury = useCallback(() => {
    const injuryIncludesNone = uofInjuryDetails?.some(type =>
      type?.name?.includes("None"),
    );
    if (injuryIncludesNone) {
      const noneInjuryRemoved = uofInjuryDetails?.filter(
        type => !type?.name?.includes("None"),
      );
      const injuryMockEvent = {
        target: {
          type: "useEffect",
          name: "uofInjuryDetails",
          value: noneInjuryRemoved,
        },
      };
      handleChange(injuryMockEvent, true, false);
    }
  }, [handleChange, uofInjuryDetails]);

  //uofInstance
  useEffect(() => {
    if (uofInstance?.name?.includes("None")) {
      //find the nones
      const noneInstanceType = uofInstanceTypess?.find(
        ({ name }) => name === "None",
      );
      const noneInjuryDetail = uofInjuryDetailss?.find(
        ({ name }) => name === "None",
      );

      const typeMockEvent = {
        target: {
          type: "useEffect",
          name: "uofInstanceTypes",
          value: [noneInstanceType],
        },
      };

      const injuryMockEvent = {
        target: {
          type: "useEffect",
          name: "uofInjuryDetails",
          value: [noneInjuryDetail],
        },
      };
      handleChange(typeMockEvent, true, false);
      handleChange(injuryMockEvent, true, false);
    }
    if (uofInstance?.name?.includes("Threatened")) {
      removeNoneFromUofType();
      removeNoneFromUofInjury();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uofInjuryDetailss, uofInstance, uofInstanceTypess]);

  //uofInstanceTypes
  useEffect(() => {
    //1. If the value is not None
    //2. Ensure the value of Use of Force is Threatened/Used
    //3. Clear any Nones from the selected component
    const typeOfForceUsed = uofInstanceTypes?.some(
      type =>
        type?.name?.includes("Threatened") ||
        type?.name?.includes("Force Used"),
    );
    const uofInstanceUsed = uofInstance?.name?.includes("Force");
    if (typeOfForceUsed && !uofInstanceUsed) {
      //the type of force shows forced was used but use of force is none
      //set uofInstance to used/threatened
      const uofInstanceUsedThreatened = uofInstances?.find(type =>
        type?.name?.includes("Threatened"),
      );
      const mockEvent = {
        target: {
          type: "useEffect",
          name: "uofInstance",
          value: uofInstanceUsedThreatened,
        },
      };
      handleChange(mockEvent, true, false);
    }
    if (typeOfForceUsed) {
      removeNoneFromUofType();
      removeNoneFromUofInjury();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uofInstanceTypes]);

  //uofInjuryDetails
  useEffect(() => {
    //1. If the value is not None
    //2. Ensure the value of Use of Force is Threatened/Used
    //3. Clear any Nones from the selected component
    const injuryOccurred = uofInjuryDetails?.some(
      type => !type?.name?.includes("None"),
    );
    const uofInstanceUsed = uofInstance?.name?.includes("Force");

    if (injuryOccurred && !uofInstanceUsed) {
      //the injury shows forced was used but use of force is none
      //set uofInstance to used/threatened
      const uofInstanceUsedThreatened = uofInstances?.find(type =>
        type?.name?.includes("Threatened"),
      );
      const mockEvent = {
        target: {
          type: "useEffect",
          name: "uofInstance",
          value: uofInstanceUsedThreatened,
        },
      };
      handleChange(mockEvent, true, false);
    }
    if (injuryOccurred) {
      //type of force set to used and need to remove None
      removeNoneFromUofType();
      removeNoneFromUofInjury();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uofInjuryDetails]);

  const addStyling = (value, showRedBox = false) => {
    const noValue = (Array.isArray(value) && value?.length === 0) || !value;
    return noValue && (showValidation || showRedBox)
      ? classes.vcvc_required
      : {};
  };
  return (
    <UOFContainer>
      <SingleDropDown
        required={showValidation}
        handleChange={handleChange}
        stateName={"uofInstance"}
        value={uofInstance}
        options={uofInstances}
        title={"Use\xa0Of\xa0Force"}
        classStyle={clsx(
          classes.formControl,
          classes.fixedWidth,
          classes.fitHeight,
          classes.spacingToRight,
          addStyling(uofInstance),
        )}
        inputLabel={inputLabel}
        labelWidth={labelWidth}
        userRoles={userRoles}
        labelStyle={{ fontSize: "1rem", marginBottom: "9px" }}
        {...props}
      />
      <MultiDropDownObjects
        required={showValidation}
        id={"uofInstanceTypes"}
        formStyle={clsx(
          classes.formControl,
          classes.spacingToRight,
          classes.fitHeight,
          addStyling(uofInstanceTypes, !!uofInstance),
        )}
        labelStyle={classes.multiInputLabel}
        title={"Types\xa0Of\xa0Force"}
        selectStyle={null}
        chipsStyle={classes.chips}
        chipStyle={classes.chip}
        stateName={"uofInstanceTypes"}
        //this handleChange might have to change to a multiChange
        handleChange={handleChange}
        selectedValues={
          uofInstanceTypes
            ? uofInstanceTypess.filter(option =>
                uofInstanceTypes?.some(type => option.id === type?.id),
              )
            : []
        }
        options={uofInstanceTypess?.length > 0 ? uofInstanceTypess : []}
        userRoles={userRoles}
        optionDisabled={option =>
          uofInstance?.name?.includes("Force") && option?.name?.includes("None")
        }
        {...props}
      />
      <MultiDropDownObjects
        required={showValidation}
        id={"uofInjuryDetails"}
        formStyle={clsx(
          classes.formControl,
          classes.spacingToRight,
          classes.fitHeight,
          addStyling(uofInjuryDetails, !!uofInstance),
        )}
        labelStyle={classes.multiInputLabel}
        title={"UOF\xa0Injuries"}
        selectStyle={null}
        chipsStyle={classes.chips}
        chipStyle={classes.chip}
        stateName={"uofInjuryDetails"}
        //this handleChange might have to change to a multiChange
        handleChange={handleChange}
        selectedValues={
          uofInjuryDetails
            ? uofInjuryDetailss?.filter(option =>
                uofInjuryDetails?.some(type => option.id === type?.id),
              )
            : []
        }
        options={uofInjuryDetailss?.length > 0 ? uofInjuryDetailss : []}
        userRoles={userRoles}
        optionDisabled={option =>
          uofInjuryDetails?.some(val => !val?.name?.includes("None")) &&
          option?.name?.includes("None")
        }
        {...props}
      />
    </UOFContainer>
  );
};

export default UseOfForce;
